module.exports = __webpack_public_path__ + "static/media/spinner.a596700e.svg";